import moment from 'moment';
import mock from 'src/utils/mock';

const notifications = [
  {
    id: '5e8883f1b51cc1956a5a1ec0',
    createdAt: moment()
      .subtract(2, 'hours')
      .toDate()
      .getTime(),
    description: 'Dummy text',
    title: 'Nueva tarea',
    type: 'order_placed'
  },

  {
    id: '5e8883fca0e8612044248ecf',
    createdAt: moment()
      .subtract(3, 'days')
      .toDate()
      .getTime(),
    description: 'Dummy text',
    title: 'Operario en camino',
    type: 'item_shipped'
  }
];

mock.onGet('/api/notifications').reply(200, { notifications });
